module.exports = __webpack_public_path__ + "img/detail.f17da3e2.png";